import React from 'react'
import {
    Card, CardImg, CardText, CardBody, UncontrolledCollapse,
    Button,
    Container
} from 'reactstrap';

import VendedoresInicio from '../../../../public/img/Help/VendedoresInicio.png';
import VendedoresNotificaciones from '../../../../public/img/Help/VendedoresNotificaciones.png';
import VendedoresHabilitacionMovil from '../../../../public/img/Help/VendedoresHabilitacionMovil.png';
import VendedoresCreacion from '../../../../public/img/Help/VendedoresCreacion.png';


const SigePedidos = () => {
    return (
        <Container fluid className="rounded contenedor-scrolleable">
            <header>
                <h2 className="text-center">SIGE Pedidos</h2>
                <h6>En esta sección encontrara información referente a la aplicación SIGE Pedidos (disponible en Google PlayStore) así como las funcionalidades relacionadas a los vendedores que utilicen dicha aplicación.</h6>
            </header>
            <div>
                <Button color="primary" id="vendedoresInicio" style={{ marginBottom: '1rem' }}>
                    ¿Como comienzo a usar la aplicación?
                </Button>
                <UncontrolledCollapse toggler="#vendedoresInicio">
                    <Card>
                        <CardImg top width="100%" src={VendedoresInicio} className="img-fluid" alt="Vendedores Inicio" title="Sección Vendedores" />
                        <CardBody>
                            <CardText>En la sección vendedores podra visualizar los vendedores cargados que actualmente existen. Para poder comenzar a utilizar la aplicación se debe crear una cuenta a algún vendedor de interés.</CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="vendedoresCreacion" style={{ marginBottom: '1rem' }}>
                    ¿Como creo una cuenta de usuario al vendedor?
                </Button>
                <UncontrolledCollapse toggler="#vendedoresCreacion">
                <Card>
                    <CardImg top src={VendedoresCreacion} className="img-modal-content" alt="Vendedores Creacion" title="Vendedor Creación" />
                    <CardBody>
                        <CardText>
                        Hay ciertos datos que deben ser provistos:
                            <ol>
                                <li>Punto de Venta: Corresponde al punto de venta que se le asignara al vendedor. Es de interés separar los pedidos que distintos vendedores generen a fin de que un vendedor en el panel de gestión solo vea los pedidos que él mismo genero.</li>
                                <li>Username / Nombre de Usuario: Se define mediante la union entre este campo más "@empresa", por ejemplo: "agustin" y "@montehermoso" resulta en un usuario "agustin@montehermoso"</li>
                                <li>Password / Contraseña: Requerido que la contraseña a usar tenga 6 ó más dígitos.</li>
                                <li>Habilitado: Si esta ó no habilitado en general para el uso del panel de gestión como de la aplicación móvil.</li>
                            </ol>
                        </CardText>
                    </CardBody>
                </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="vendedoresHabilitacion" style={{ marginBottom: '1rem' }}>
                Tengo creado un vendedor y está habilitado. ¿Como habilito su móvil?
                </Button>
                <UncontrolledCollapse toggler="#vendedoresHabilitacion">
                <Card>
                    <CardImg top src={VendedoresHabilitacionMovil} className="img-modal-content" alt="Vendedores Habilitacion" title="Vendedor Habilitación" />
                    <CardBody>
                        <CardText>Sirve para habilitar o denegar el Login al vendedor desde la aplicación móvil.</CardText>
                    </CardBody>
                </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="vendedoresNotificaciones" style={{ marginBottom: '1rem' }}>
                ¿Como envió notificaciones a un móvil?
                </Button>
                <UncontrolledCollapse toggler="#vendedoresNotificaciones">
                    <Card>
                        <CardImg top src={VendedoresNotificaciones} className="img-modal-content" alt="Vendedores Notificaciones" title="Vendedor Notificaciones" />
                        <CardBody>
                            <CardText>Es posible enviar notificaciones a un vendedor en particular.</CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
            </div>
        </Container>
    )
}
export default SigePedidos;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Paneles/SigePedidos.js